export default "__VITE_ASSET__c1a6099a__"